module.exports = __webpack_public_path__ + "media/images/meta/akt/favicon-6bfbb85ffe7e6fdbaf8658380831d462.png";